import { render } from "./addSeller.vue?vue&type=template&id=70926574&scoped=true"
import script from "./addSeller.vue?vue&type=script&lang=js"
export * from "./addSeller.vue?vue&type=script&lang=js"

import "./addSeller.vue?vue&type=style&index=0&id=70926574&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70926574"]])

export default __exports__